
export class WorkerSuggestion {
    workerId: number;
    firstName: string;
    lastName: string;
    reason: string;
    displayRank: number;
    
    static FromJson(o: any) : WorkerSuggestion {
        let w = new WorkerSuggestion();
        w.workerId = o.workerId;
        w.firstName = o.firstName;
        w.lastName = o.lastName;
        w.reason = o.reason;
        w.displayRank = o.displayRank;
        return w;
    }
    
}

export class WorkersSuggestionReport {
    showReport: boolean = false;
    message: string;
    candidates: Array<WorkerSuggestion> = [];
    
    static FromJson(o: any) : WorkersSuggestionReport {
        let report = new WorkersSuggestionReport();
        report.showReport = o.showReport;
        report.message = o.message;
        if(o.candidates?.length > 0){
            for(let c of o.candidates){
                report.candidates.push(WorkerSuggestion.FromJson(c));
            }
            report.candidates.sort((a,b) => a.displayRank - b.displayRank);
        }
        return report;
    }
    
}